import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {QueryClientProvider} from '@tanstack/react-query';
import {App} from './app/App';
import {createQueryClient} from './app/query-client';
import './styles/enterprise.css';
import './styles/prototype.css';
import './styles/erp-theme.css';
const client=createQueryClient();
// StrictMode double-mount races session restore against hard navigations in Playwright UAT.
createRoot(document.getElementById('root')!).render(<QueryClientProvider client={client}><BrowserRouter><App/></BrowserRouter></QueryClientProvider>);
